import styled from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { StrategyEnum } from './dropdown.constants';
import { type DropdownListPops } from './dropdown.types';

export const DropdownList = styled.div<DropdownListPops>`
    position: ${(p) => (p.strategy === StrategyEnum.PAGE ? 'absolute' : 'fixed')};
    bottom: ${rem(-4)};
    display: ${(p) => (p.isVisible ? 'inherit' : 'none')};
    z-index: ${Z_INDEX.level2};
    height: min-content;
`;